import axios from 'axios';

import {
  openErrorPopup,
  openPopup,
  closePopup,
} from 'containers/App/actions';

import {
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  SET_PASSWORD_RECOVERY_CHANNEL,
  SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS,
  SET_PASSWORD_RECOVERY_CHANNEL_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  FETCH_OFFER,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFER_ERROR,
  SAVE_ACCESS_CONFIG,
  SAVE_ACCESS_CONFIG_SUCCESS,
  SAVE_ACCESS_CONFIG_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
  RESET_ERROR,
  OFFER_TYPE,
  CONFIRMATION_POPUP_KEY,
  EDITING_POPUP_KEY,
  FETCH_INTERNET_LOGIN,
  FETCH_INTERNET_LOGIN_SUCCESS,
  FETCH_INTERNET_LOGIN_ERROR,
  CHANGE_INTERNET_LOGIN,
  CHANGE_INTERNET_LOGIN_SUCCESS,
  CHANGE_INTERNET_LOGIN_ERROR,
  LOGIN_ALREADY_EXISTS_ERROR,
  CHANGE_INTERNET_PASSWORD,
  CHANGE_INTERNET_PASSWORD_SUCCESS,
  CHANGE_INTERNET_PASSWORD_ERROR,
} from './constants';

export function fetchPointsStart() {
  return {
    type: FETCH_POINTS,
  };
}

export function fetchPointsSuccess(data) {
  return {
    data,
    type: FETCH_POINTS_SUCCESS,
  };
}

export function fetchPointsError(error) {
  return {
    error,
    type: FETCH_POINTS_ERROR,
  };
}

export function fetchOfferStart() {
  return {
    type: FETCH_OFFER,
  };
}

export function fetchOfferSuccess(data) {
  return {
    data,
    type: FETCH_OFFER_SUCCESS,
  };
}

export function fetchOfferError(error) {
  return {
    error,
    type: FETCH_OFFER_ERROR,
  };
}

export function saveAccessConfigStart() {
  return {
    type: SAVE_ACCESS_CONFIG,
  };
}

export function saveAccessConfigSuccess(data) {
  return {
    data,
    type: SAVE_ACCESS_CONFIG_SUCCESS,
  };
}

export function saveAccessConfigError(error) {
  return {
    error,
    type: SAVE_ACCESS_CONFIG_ERROR,
  };
}

export function setPasswordRecoveryChannelStart() {
  return {
    type: SET_PASSWORD_RECOVERY_CHANNEL,
  };
}

export function setPasswordRecoveryChannelSuccess(notificationType) {
  return {
    data: notificationType,
    type: SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS,
  };
}

export function handleSettingPasswordRecoveryChannelError(error) {
  return {
    error,
    type: SET_PASSWORD_RECOVERY_CHANNEL_ERROR,
  };
}

export function setPasswordRecoveryChannelError(error) {
  return (dispatch) => {
    dispatch(handleSettingPasswordRecoveryChannelError(error));
    dispatch(openErrorPopup());
  };
}

export function togglePointEditingStateForSpecificPoint(data) {
  return {
    data,
    type: TOGGLE_POINT_EDITING_STATE,
  };
}

export function togglePointEditingState(data) {
  return (dispatch) => {
    dispatch(togglePointEditingStateForSpecificPoint(data));

    if (data.isEditing) {
      dispatch(openPopup(EDITING_POPUP_KEY));
    } else {
      dispatch(closePopup());
    }
  };
}

export function toggleConfirmationCodePopupForSpecificPoint(data) {
  return {
    data,
    type: TOGGLE_CONFIRMATION_CODE_POPUP,
  };
}

export function saveNotificationPointStart(type) {
  return {
    data: type,
    type: SAVE_NOTIFICATION_POINT,
  };
}

export function saveNotificationPointSuccess(data) {
  return {
    data,
    type: SAVE_NOTIFICATION_POINT_SUCCESS,
  };
}

export function handleSavingNotificationPointError(notificationType, error) {
  return {
    error,
    data: notificationType,
    type: SAVE_NOTIFICATION_POINT_ERROR,
  };
}

export function saveNotificationPointError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSavingNotificationPointError(notificationType, error));
    dispatch(openErrorPopup());
  };
}

export function confirmNotificationPointCodeStart(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE,
  };
}

export function confirmNotificationPointCodeSuccess(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function confirmNotificationPointCodeError(notificationType) {
  return {
    data: notificationType,
    type: CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function changePasswordStart() {
  return {
    type: CHANGE_PASSWORD,
  };
}

export function changePasswordSuccess() {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
  };
}

export function changePasswordError(error) {
  return {
    error,
    type: CHANGE_PASSWORD_ERROR,
  };
}

export function resetNotificationPointCodeValidation(data) {
  return {
    data,
    type: RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  };
}

export function sendNotificationPointCodeStart(notificationType) {
  return {
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE,
  };
}

export function sendNotificationPointCodeSuccess(notificationType) {
  return {
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  };
}

export function handleSendingNotificationPointCodeError(notificationType, error) {
  return {
    error,
    data: notificationType,
    type: SEND_NOTIFICATION_POINT_CODE_ERROR,
  };
}

export function fetchInternetLoginStart() {
  return {
    type: FETCH_INTERNET_LOGIN,
  };
}

export function fetchInternetLoginSuccess(data) {
  return {
    type: FETCH_INTERNET_LOGIN_SUCCESS,
    data,
  };
}

export function fetchInternetLoginError(error) {
  return {
    type: FETCH_INTERNET_LOGIN_ERROR,
    error,
  };
}

export function changeInternetLogindStart() {
  return {
    type: CHANGE_INTERNET_LOGIN,
  };
}

export function changeInternetLoginSuccess(fttbConfigureConnectionHelpUrl) {
  return {
    type: CHANGE_INTERNET_LOGIN_SUCCESS,
    payload: fttbConfigureConnectionHelpUrl,
  };
}

export function changeInternetLoginError(error) {
  return {
    type: CHANGE_INTERNET_LOGIN_ERROR,
    error,
  };
}

export function changeInternetPasswordStart() {
  return {
    type: CHANGE_INTERNET_PASSWORD,
  };
}

export function changeInternetPasswordSuccess() {
  return {
    type: CHANGE_INTERNET_PASSWORD_SUCCESS,
  };
}

export function changeInternetPasswordError(error) {
  return {
    type: CHANGE_INTERNET_PASSWORD_ERROR,
    error,
  };
}

export function sendNotificationPointCodeError(notificationType, error) {
  return (dispatch) => {
    dispatch(handleSendingNotificationPointCodeError(notificationType, error));
    dispatch(openErrorPopup({
      message: 'settings.common.sendNotificationPointCodeError',
    }));
  };
}

export function resetError() {
  return {
    type: RESET_ERROR,
  };
}

export function fetchPoints() {
  return async (dispatch) => {
    dispatch(fetchPointsStart());

    try {
      const { data: { data, error } } = await axios
        .get('/api/profile/settings/notifications/passwordrecoverychannels/');

      if (error) {
        dispatch(fetchPointsError(error));
      } else {
        dispatch(fetchPointsSuccess(data));
      }
    } catch (error) {
      dispatch(fetchPointsError(error.message));
    }
  };
}

export function fetchOffer(offerText = true) {
  return async (dispatch) => {
    dispatch(fetchOfferStart());

    try {
      const { data } = await axios.get('/api/profile/settings/offer/', {
        params: {
          offerType: OFFER_TYPE,
          offerText,
        },
      });

      if (!data) {
        dispatch(fetchOfferError('Empty data'));
      } else {
        dispatch(fetchOfferSuccess(data));
      }
    } catch (error) {
      dispatch(fetchOfferError(error.message));
    }
  };
}

export function setPasswordRecoveryChannel({ type, value }) {
  return async (dispatch) => {
    if (value) {
      dispatch(setPasswordRecoveryChannelStart());

      try {
        await axios.post('/api/profile/settings/notifications/passwordrecoverychannel/', { type });

        dispatch(setPasswordRecoveryChannelSuccess(type));
      } catch (error) {
        dispatch(setPasswordRecoveryChannelError(error.message));
      }
    }
  };
}

export function sendNotificationPointCode(type) {
  return async (dispatch) => {
    dispatch(sendNotificationPointCodeStart(type));

    try {
      await axios.post('/api/profile/settings/notifications/sendnotificationpointconfirmationcode/', { type });

      dispatch(sendNotificationPointCodeSuccess(type));
    } catch (error) {
      dispatch(sendNotificationPointCodeError(type, error.message));
    }
  };
}

export function toggleConfirmationCodePopup(data) {
  return async (dispatch) => {
    dispatch(toggleConfirmationCodePopupForSpecificPoint(data));

    if (data.isConfirmationOpened) {
      dispatch(openPopup(CONFIRMATION_POPUP_KEY));

      await dispatch(sendNotificationPointCode(data.type));
    } else {
      dispatch(closePopup());
    }
  };
}

export function confirmNotificationPointCode(data) {
  return async (dispatch) => {
    dispatch(confirmNotificationPointCodeStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/confirmnotificationpointcode/', data);

      dispatch(confirmNotificationPointCodeSuccess(data.type));

      await dispatch(toggleConfirmationCodePopup({
        type: data.type,
        isConfirmationOpened: false,
      }));
    } catch (error) {
      dispatch(confirmNotificationPointCodeError(data.type));
    }
  };
}

export function saveNotificationPoint(data) {
  return async (dispatch) => {
    dispatch(saveNotificationPointStart(data.type));

    try {
      await axios.post('/api/profile/settings/notifications/notificationpoint/', data);

      if (data.value) {
        dispatch(saveNotificationPointSuccess(data));

        await dispatch(toggleConfirmationCodePopup({
          type: data.type,
          isConfirmationOpened: true,
        }));
      } else {
        dispatch(saveNotificationPointSuccess(data));
      }
    } catch (error) {
      dispatch(saveNotificationPointError(data.type, error.message));
    }
  };
}

export function changePassword(data) {
  return async (dispatch) => {
    dispatch(changePasswordStart());

    try {
      await axios.post('/api/profile/settings/changepassword/', data);

      dispatch(changePasswordSuccess());
    } catch (error) {
      dispatch(changePasswordError(error.message));
    }
  };
}

export function saveAccessConfig(data) {
  return async (dispatch) => {
    dispatch(saveAccessConfigStart());

    try {
      await axios.post('/api/profile/settings/offer/', {
        ...data,
        offerType: OFFER_TYPE,
      });

      dispatch(saveAccessConfigSuccess(data));
    } catch (error) {
      dispatch(saveAccessConfigError(error.message));
    }
  };
}

export function fetchInternetLogin() {
  return async (dispatch) => {
    dispatch(fetchInternetLoginStart());
    try {
      const { data } = await axios.get('/api/profile/settings/alias/');
      dispatch(fetchInternetLoginSuccess(data));
    } catch (error) {
      dispatch(fetchInternetLoginError(error.message));
    }
  };
}

export function changeInternetLogin(login) {
  return async (dispatch) => {
    dispatch(changeInternetLogindStart());
    try {
      const {
        data: {
          isSuccess,
          isLoginAlreadyExist,
          fttbConfigureConnectionHelpUrl,
        },
      } = await axios.post('/api/profile/settings/alias/create', { alias: login });

      if (isSuccess) {
        dispatch(changeInternetLoginSuccess(fttbConfigureConnectionHelpUrl));
      } else {
        dispatch(changeInternetLoginError(isLoginAlreadyExist ? LOGIN_ALREADY_EXISTS_ERROR : 'unknown'));
        if (!isLoginAlreadyExist) {
          dispatch(openErrorPopup());
        }
      }
    } catch (error) {
      dispatch(changeInternetLoginError(error.message));
      dispatch(openErrorPopup());
    }
  };
}

export function changeInternetPassword(password) {
  return async (dispatch) => {
    dispatch(changeInternetPasswordStart());
    try {
      await axios.post(
        '/api/profile/settings/changepassword/',
        { newPassword: password, isConvergent: true },
      );

      dispatch(changeInternetPasswordSuccess());
    } catch (error) {
      dispatch(changeInternetPasswordError(error.message));
    }
  };
}

export function fetchInitialData() {
  return (dispatch) => {
    dispatch(fetchPoints());
    dispatch(fetchOffer());
    dispatch(fetchInternetLogin());
  };
}
